import {Pipe, PipeTransform} from '@angular/core';
import {Company} from '../classes/company';

@Pipe({
    name: 'companyName'
})
export class CompanyNamePipe implements PipeTransform {
    transform(companies: Company[], companyId: number): string {
        const company = companies?.find(c => c.id === companyId);
        let companyName = company?.short ?? ''
        if (companyName == '') {
            companyName = company?.name ?? '';
        }
        return companyName;
    }
}

